import {
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Dialog,
} from '@mui/material';
// import { Download, Print } from '@mui/icons-material';
import { Download, Print, UploadFile } from '@mui/icons-material';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import useAppStore from 'store/useAppStore';
import { useCallback, useState } from 'react';
import PrintDialog from './GlobalScriptFlowCard/PrintDialog.js';
import _chart from '_chart.js';
import { getScripts } from 'utils/getScript.js';
import _fullChart from '_fullChart.js';

// 0529 新增
// import { useLazyDownloadDesignSpecWordQuery } from 'services/api';
import { useLazyDownloadDesignSpecWordQuery, useUploadSpecInputMutation } from 'services/api';

export default function ProjectOperationCard() {

  //0529
  const selectedProject = useAppStore((state) => state.selectedProject);


  // const selectedProject = useAppStore((state) => state.selectedProject); // 💡 2. 新增這行，用來取目前選取的專案資料
  const projectName = useAppStore(
    (state) => state.selectedProject.project_name,
  );
  const [editProjectName, setEditProjectName] = useState(projectName);

  // 0529 新增
  // const [triggerDownloadWord, { isLoading: isDownloading }] = useLazyDownloadDesignSpecWordQuery();
  const [triggerDownloadWord, { isLoading: isDownloadingSpec }] = useLazyDownloadDesignSpecWordQuery();

  // 1028 新增
  const [uploadSpecInput, { isLoading: isUploadingSpec }] = useUploadSpecInputMutation();

  const handleUploadSpecInput = (fileType) => async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';            // 讓同一個檔案可以再選一次
    if (!file) return;
    const user = useAppStore.getState().user;
    const formData = new FormData();
    formData.append('user_id', user.id || '');
    formData.append('comp_name', user.company || '');
    formData.append('project_id', selectedProject.project_id);
    formData.append('file_type', fileType);   // 'point_list' 或 'io_input'
    formData.append('file', file);
    try {
      const res = await uploadSpecInput(formData).unwrap();
      showNotification?.(res.message || '上傳成功', 'success');
    } catch (error) {
      console.error('上傳失敗:', error);
      showNotification?.(error?.data?.message || '上傳失敗', 'error');
    }
  };

  const currentProjectName = editProjectName ? editProjectName : projectName;
  const materialDevices = useAppStore((state) => state.materialDevices);
  const stations = useAppStore((state) => state.stations);
  const scripts = useAppStore((state) => state.scripts);
  const fullScript = useAppStore((state) => state.editedFullScript);
  const showNotification = useAppStore((state) => state.showNotification);

  const [printDialogVisible, setPrintDialogVisible] = useState(false);
  const onClose = useCallback(() => {
    setPrintDialogVisible(false);
  }, []);

  // 0529 新增
  // 💡 修正 2：補上原本缺失的 handleDownload 避免按鈕綁定報錯
  // const handleDownload = () => {
  //   console.log("下載普通專案...", selectedProject);
  //   showNotification?.("下載普通專案中...", "info");
  // };

  // 生成 SVG 流程圖
  const generateSVGContent = () => {
    return _fullChart.current.outerHTML;
  };

  // 將 SVG 轉換為圖片
  const convertSVGToImage = async (svgContent) => {
    return new Promise((resolve, reject) => {
      try {
        // 創建一個臨時的 div 來包含 SVG
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        tempDiv.style.width = '800px';
        tempDiv.style.height = '500px';
        tempDiv.style.backgroundColor = 'white';
        tempDiv.innerHTML = svgContent;
        document.body.appendChild(tempDiv);

        // 使用 html2canvas 截圖
        html2canvas(tempDiv, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          width: 800,
          height: 500,
          backgroundColor: '#ffffff',
        })
          .then((canvas) => {
            const dataURL = canvas.toDataURL('image/png');
            document.body.removeChild(tempDiv);
            resolve(dataURL);
          })
          .catch((error) => {
            document.body.removeChild(tempDiv);
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  };

  // 下載 PDF
  const handleDownload = async () => {
    try {
      showNotification('正在生成 PDF...', 'info');
      // 1. 生成流程圖圖片
      let flowchartImg = null;
      try {
        const svgContent = generateSVGContent();
        flowchartImg = await convertSVGToImage(svgContent);
      } catch {
        flowchartImg = null;
      }
      // 2. 建立 PDF
      const pdf = new jsPDF('p', 'mm', 'a4');
      // 註冊中文字體
      pdf.setFont('NotoSansTC-Regular');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 15;
      const usableWidth = pageWidth - margin * 2;
      let y = 20;

      // 標題
      pdf.setFontSize(18);
      pdf.text(
        (currentProjectName || '未命名專案') + ' - PLC 腳本報告',
        pageWidth / 2,
        y,
        { align: 'center' },
      );
      y += 14;

      // 物料移動設備表格
      pdf.setFontSize(14);
      pdf.text('1. 物料移動設備列表', margin, y);
      y += 8;
      pdf.setFontSize(10);
      const materialDeviceKeys = useAppStore.getState().materialDeviceKeys;
      const deviceColWidth = usableWidth / materialDeviceKeys.length;
      materialDeviceKeys.forEach((key, index) => {
        pdf.text(key, margin + index * deviceColWidth, y);
      });
      y += 6;
      // 表頭下方畫線
      pdf.setDrawColor(180);
      pdf.line(margin, y - 4, pageWidth - margin, y - 4);
      const tableLineHeight = 6;

      materialDevices.forEach((d) => {
        if (y > 280) {
          pdf.addPage();
          y = 20;
        }

        const linesPerColumn = materialDeviceKeys.map((key) => {
          return pdf.splitTextToSize(d[key] || '', 38);
        });
        const maxLines = Math.max(
          ...linesPerColumn.map((lines) => lines.length),
        );

        for (let i = 0; i < maxLines; i++) {
          materialDeviceKeys.forEach((key, index) => {
            const x = margin + index * deviceColWidth;
            pdf.text(linesPerColumn[index][i] || '', x, y);
          });
          y += tableLineHeight;
        }
        // 每筆資料下方畫線
        pdf.line(margin, y - 4, pageWidth - margin, y - 4);
      });
      y += 8;

      const stationKeys = useAppStore.getState().stationKeys;
      const stationColWidth = usableWidth / stationKeys.length;

      // 站台表格
      pdf.setFontSize(14);
      pdf.text('2. 站台列表', margin, y);
      y += 8;
      pdf.setFontSize(10);
      stationKeys.forEach((key, index) => {
        pdf.text(key, margin + index * stationColWidth, y);
      });
      y += 6;
      // 表頭下方畫線
      pdf.setDrawColor(180);
      pdf.line(margin, y - 4, pageWidth - margin, y - 4);
      stations.forEach((d) => {
        if (y > 280) {
          pdf.addPage();
          y = 20;
        }

        const linesPerColumn = stationKeys.map((key) => {
          return pdf.splitTextToSize(d[key] || '', 38);
        });
        const maxLines = Math.max(
          ...linesPerColumn.map((lines) => lines.length),
        );

        for (let i = 0; i < maxLines; i++) {
          stationKeys.forEach((key, index) => {
            const x = margin + index * deviceColWidth;
            pdf.text(linesPerColumn[index][i] || '', x, y);
          });
          y += tableLineHeight;
        }
        // 每筆資料下方畫線
        pdf.line(margin, y - 4, pageWidth - margin, y - 4);
      });
      y += 8;

      // 流程圖
      if (flowchartImg) {
        if (y > 180) {
          pdf.addPage();
          y = 20;
        }
        pdf.setFontSize(14);
        pdf.text('3. 流程圖', margin, y);
        y += 6;
        const svgOriginalWidth = 800;
        const svgOriginalHeight = 500;
        const imgWidth = pageWidth - margin * 2;
        const imgHeight = (imgWidth * svgOriginalHeight) / svgOriginalWidth;
        pdf.addImage(flowchartImg, 'PNG', margin, y, imgWidth, imgHeight);
        y += imgHeight + 8;
      }

      // 區段腳本內容
      pdf.setFontSize(14);
      if (y > 250) {
        pdf.addPage();
        y = 20;
      }
      pdf.text('4. 區段流程列表', margin, y);
      y += 8;
      pdf.setFontSize(11);
      getScripts(scripts).forEach((script, idx) => {
        if (y > 250) {
          pdf.addPage();
          y = 20;
        }
        pdf.text(
          `腳本 ${idx + 1}: ${script['區段腳本名稱'] || '未命名腳本'}`,
          margin,
          y,
        );
        y += 6;
        pdf.text(`起始站台: ${script['起始工站'] || ''}`, margin, y);
        y += 6;
        pdf.text(`目標站台: ${script['目標工站'] || ''}`, margin, y);
        y += 6;
        pdf.text(`移動設備: ${script['移動設備'] || ''}`, margin, y);
        y += 6;
        // 腳本內容多行自動換行
        const scriptLines = pdf.splitTextToSize(
          script.segScript || '尚未生成腳本內容',
          pageWidth - margin * 2,
        );
        scriptLines.forEach((line) => {
          if (y > 280) {
            pdf.addPage();
            y = 20;
          }
          pdf.text(line, margin + 4, y);
          y += 6;
        });
        y += 4;
      });

      // 全局腳本內容
      if (fullScript) {
        if (y > 250) {
          pdf.addPage();
          y = 20;
        }
        pdf.setFontSize(14);
        pdf.text('5. 全局腳本流程', margin, y);
        y += 8;
        pdf.setFontSize(11);
        const fullScriptLines = pdf.splitTextToSize(
          fullScript,
          pageWidth - margin * 2,
        );
        fullScriptLines.forEach((line) => {
          if (y > 280) {
            pdf.addPage();
            y = 20;
          }
          pdf.text(line, margin + 4, y);
          y += 6;
        });
      }

      // 生成時間
      if (y > 270) {
        pdf.addPage();
        y = 20;
      }
      pdf.setFontSize(9);
      pdf.setTextColor(102, 102, 102);
      pdf.text(`生成時間: ${new Date().toLocaleString()}`, margin, y + 10);

      // 下載 PDF
      const fileName = `${currentProjectName || '專案'}_PLC腳本報告.pdf`;
      pdf.save(fileName);
      showNotification('PDF 下載成功！', 'success');
    } catch (error) {
      console.error('生成 PDF 錯誤:', error);
      showNotification('生成 PDF 失敗', 'error');
    }
  };

  // ==============================================================================
  //  【0529 修正版：處理下載 Word 規格書的點擊事件】
  // ==============================================================================
  const handleDownloadDesign = async () => {
    // 優先從當前選取的專案中取得 case_id 與 version，若無則使用預設範例值
    const project_id = selectedProject.project_id;
    const user = useAppStore.getState().user;

    // 【獨立後端伺服器網址】
    const SPEC_API_URL = "https://140.96.111.8:8023";

    try {
      // 💡 修正 1：直接 await 觸發並進行 unwrap() 取得後端回傳的原始 Blob 資料
      // const blob = await triggerDownloadWord({
      //   specApiBaseUrl: SPEC_API_URL,
      //   comp_name: user.company || '',
      //   project_id: project_id
      // }).unwrap();
      const blob = await triggerDownloadWord({
        specApiBaseUrl: SPEC_API_URL,
        user_id: user.id || '',          // ← 新增
        comp_name: user.company || '',
        project_id: project_id
      }).unwrap();

      // 💡 防禦性檢查：確保撈到的是合法的 Blob 物件，避免後端報錯卻下載成空檔案
      if (!(blob instanceof Blob)) {
        throw new Error("回傳的資料格式不是標準的 Blob 檔案");
      }

      // 設定下載下來的檔案名稱
      const filename = `專案設計規格書.docx`;

      // 建立虛擬 <a> 標籤，點擊觸發瀏覽器下載
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // 清除臨時節點與記憶體
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      showNotification?.("規格書下載成功！", "success");

    } catch (error) {
      // 💡 修正 2：標準的 unwrap 會將後端 Error 拋到這裡，能精準捕捉
      console.error("下載 Word 規格書失敗:", error);
      alert("無法下載 Word 檔案，請確認 API 伺服器狀態或網路連線！");
    }
  };


  // 列印
  const handlePrint = async () => {
    setPrintDialogVisible(true);
    return;
  };

  //【0529 修正版：處理下載 Word 規格書的點擊事件】
  // 💡 修正 2：定義好關閉 Dialog 的專用函式，避免 onClose 未定義報錯
  const handleClosePrintDialog = () => {
    setPrintDialogVisible(false);
  };

  return (
    <>
      <Card>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            專案操作
          </Typography>

          {/* 專案名稱輸入框 */}
          <TextField
            label="專案名稱"
            fullWidth
            value={editProjectName}
            onChange={(e) => setEditProjectName(e.target.value)}
          />


          {/* 下載專案按鈕 */}
          <Button
            variant="contained"
            size="medium"
            fullWidth
            startIcon={<Download />}
            onClick={handleDownload}
          >
            下載專案
          </Button>

          {/* ===== 新增：上傳規格書輔助資料 ===== */}
          <Button variant="outlined" size="medium" fullWidth component="label"
            startIcon={<UploadFile />} disabled={isUploadingSpec}>
            上傳手臂配置點
            <input hidden type="file" accept=".xlsx,.xls,.csv,.pdf,.txt,.md,.json"
              onChange={handleUploadSpecInput('point_list')} />
          </Button>

          <Button variant="outlined" size="medium" fullWidth component="label"
            startIcon={<UploadFile />} disabled={isUploadingSpec}>
            上傳 IO 點資料表
            <input hidden type="file" accept=".xlsx,.xls,.csv,.pdf,.txt,.md,.json"
              onChange={handleUploadSpecInput('io_input')} />
          </Button>
          {/* ===== 新增結束 ===== */}


          {/* 0529 新增：下載專案設計規格書按鈕 */}
          <Button
            variant="contained"
            size="medium"
            fullWidth
            startIcon={<Download />}
            onClick={handleDownloadDesign}
            disabled={isDownloadingSpec} // 下載過程中禁用按鈕，防止使用者重複點擊
          >
            {isDownloadingSpec ? '規格書生成下載中...' : '下載專案設計規格書'}
          </Button>

          {/* 列印專案按鈕 */}
          <Button
            variant="contained"
            size="medium"
            fullWidth
            startIcon={<Print />}
            onClick={handlePrint}
          >
            列印專案
          </Button>
        </CardContent>
      </Card>
      <Dialog fullScreen open={printDialogVisible} onClose={onClose}>
        <PrintDialog
          onClose={onClose}
          currentProjectName={currentProjectName}
        />
      </Dialog>
    </>
  );
}
